import React from 'react';
import {useTranslation} from 'react-i18next';
import {ANALYTICS_CHANNEL} from '../channels/channels';
import {HELP_GA4_CUSTOM_FIELDS, LinkToArticle} from '../help_center/LinkToArticle';

/**
 * ¿El cliente tiene alguna cuenta de GA4? Se contesta con las cuentas que ya trae el form-data
 * (`ad_accounts`, con `channel` y `agency_client_id`), sin pedir nada al backend.
 */
export function clientHasGa4Account(adAccounts, agencyClientId) {
    if (agencyClientId === null || agencyClientId === undefined || agencyClientId === '') return false;
    return (adAccounts || []).some((aa) => aa.channel === ANALYTICS_CHANNEL
        && String(aa.agency_client_id) === String(agencyClientId));
}

/**
 * «Búsqueda sin resultados» de los selectores de campos (Informes y Explorador).
 *
 * Dashbo sólo ofrece los campos personalizados de GA4 que están REGISTRADOS en la propiedad
 * (grupo «GA4 · Personalizadas»). Quien busca un parámetro que manda en sus eventos pero nunca
 * registró (`event_campaign`) no lo encontraba, la lista quedaba vacía sin decir nada y la pregunta
 * terminaba en soporte. Con GA4 en el cliente, el mensaje dice por qué y lleva al artículo; sin GA4,
 * la segunda línea no aplica y no se muestra.
 *
 * `query` es el texto tal como lo escribió el usuario: va interpolado con `escapeValue: false`,
 * o un `/` saldría como `&#x2F;` (React ya escapa lo que pinta).
 *
 * Las líneas son <div> y no <p> a propósito: en los dos modales, una regla legacy de
 * `_columns-selector-modal.scss` (`.modal-body > div > div:last-child > div:first-child p`, la del
 * «no hay columnas seleccionadas») alcanza a todo <p> de la columna de la izquierda y lo pinta
 * gris claro e itálica (#B6B6B7, ~2:1 de contraste).
 */
export function FieldSearchEmpty({query, showGa4Hint = false}) {
    const {t} = useTranslation();
    return (
        <div className="field-search-empty" data-testid="field-search-empty" role="status">
            <div className="field-search-empty__title">
                {t('field_search_empty.not_found', {
                    query: (query || '').trim(),
                    defaultValue: 'No encontramos «{{query}}».',
                    interpolation: {escapeValue: false},
                })}
            </div>
            {showGa4Hint && (
                <div className="field-search-empty__ga4" data-testid="field-search-empty-ga4">
                    {t('field_search_empty.ga4_hint', '¿Es un parámetro de GA4? Para verlo aquí, tiene que estar registrado como dimensión personalizada en la propiedad.')}
                    <LinkToArticle article={HELP_GA4_CUSTOM_FIELDS} plain
                                   text={t('field_search_empty.ga4_link', 'Cómo registrarlo')}/>
                </div>
            )}
        </div>
    );
}
